import React from "react";
import './App.scss';
import Footer from "./components/footer";
import TopNavbar from "./components/navbar";
import DetailPage from "./pages/detailpage";
import FrontPage from "./pages/frontpage";
import GridViewPage from "./pages/gridview";
import LegalPage from "./pages/legal";
import ListPage from "./pages/listpage";
import ShoppingCart from "./pages/shoppingcart";
import ToolBar from "./components/toolbar";
import SearchModal from "./components/searchmodal";

class App extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      searchModal:false,
      currentPage:"frontpage",
      productList:{
        "book":{
          "item1":{
            "item":"item1",
            "name":"Music - A book of Quotation",
            "author":"Herb Galewitz",
            "language":"English",
            "length":"64 pages",
            "publisher":"Dover Publications",
            "age":"14 and above",
            "format":"Paperback",
            "ISBN":"978-0486415963",
            "publishyear":"2001",
            "description":"Containing more than 400 other striking quotes about music, from musicians, authors, poets, historical figures, and other celebrities, fill the pages of this entertaining, practical little book. Not all are on the serious side; many are deliciously witty: 'Her singing was mutiny on the high C's' (Hedda Hopper); 'I can hold a note as long as the Chase National Bank' (Ethel Merman); 'Donny Osmond has van Gogh's ear for music' (Orson Welles). \nThe quotations are arranged alphabetically according to author, from Fred Allen ('When Jack Benny plays the violin, it sounds as if the strings are still back in the cat') to Florian Zabach ('A musical talent is like having six fingers on one hand. You're born with it, you're different because of it, you can't do a thing about it except put it to use'). They constitute a collection that will not only be an indispensable reference for public speakers but will also delight general readers—especially music lovers—with its enduring wisdom and humor.",
            "spec":{},
            "options":{},
            "tags":"book, quote, wisdom, inspiration, literature, knowledge, book, fun facts, ",
            "img":1,
            "price":23,
            "uploaded":"6/17/2024",
          },
          "item2":{
            "item":"item2",
            "name":"What to Listen For in Music",
            "author":"Aaron Copland",
            "language":"English",
            "length":"308 pages",
            "publisher":"Signet",
            "age":"15 and above",
            "format":"Paperback",
            "ISBN":"978-0451531766",
            "publishyear":"2011",
            "description":"In this fascinating analysis of how to listen to both contemporary and classical music analytically, eminent American composer Aaron Copland offers provocative suggestions in this book that will bring readers a deeper appreciation of the most viscerally rewarding of all art forms.",
            "spec":{},
            "options":{},
            "tags":"book, Aaron Copland, wisdom, inspiration, literature, knowledge, pedagogy, artistic, culture, education, ",
            "img":1,
            "price":27,
            "uploaded":"6/17/2024",
          },
          "item3":{
            "item":"item3",
            "name":"Arrau on Music and Performance",
            "author":"Joseph Horowitz",
            "language":"English",
            "length":"336 pages",
            "publisher":"Dover Publications",
            "age":"15 and above",
            "format":"Paperback",
            "ISBN":"978-0486408460",
            "publishyear":"2011",
            "description":"Awarded an ASCAP Deems Taylor Award in 1983 for excellence in writing about music, this volume of candid conversations with the late Claudio Arrau is both a subtle portrait of one of the world`s great concert artists and a vivid exploration of his unique and intensely felt beliefs about music and piano performance. Upon its initial appearance, critical acclaim for this work included rave reviews from The New Yorker ('One of the best books about a performing artist ever written. . . . It's an enthralling, free-flowing, but shapely compound of reminiscences and of observations on music.'), and New York Magazine ('Something of a miracle, a book that actually explores the life and development of a living musician by dealing seriously with important musical issues. Each chapter sets a biographical context for a conversation . . . a fascinating and valuable book.').",
            "spec":{},
            "options":{},
            "tags":"book, Joseph Horowitz, Arrau, inspiration,musicianship, performance, knowledge, pedagogy, artistic, culture, education, ",
            "img":1,
            "price":39,
            "uploaded":"6/17/2024",
          },
          "item4":{
            "item":"item4",
            "name":"First Book about The Orchestra",
            "author":"Sam Taplin",
            "language":"English",
            "length":"N/A",
            "publisher":"Usborne Publishing Ltd",
            "age":"2 to 7",
            "format":"Hardcover",
            "ISBN":"978-1409597667",
            "publishyear":"1807",
            "description":"Young children can discover the magic of the orchestra with this sound book. Each page has an embedded button to press to hear instruments from brass to drums, as well as the whole orchestra playing together. There are snippets of information about each instrument and a QR link to listen to the complete piece of music online.",
            "spec":{},
            "options":{},
            "tags":"book, children music, early teaching, wisdom, orchestra, symphonic, band, inspiration, knowledge, child development, artistic, culture, education, ",
            "img":1,
            "price":62,
            "uploaded":"6/17/2024",
          },
          "item5":{
            "item":"item5",
            "name":"The Inner Game of Music",
            "author":"Barry Green, Timothy Gallwey",
            "language":"English",
            "length":"225 pages",
            "publisher":"Doubleday",
            "age":"12 or above",
            "format":"Paperback",
            "ISBN":"978-0385231268",
            "publishyear":"1986",
            "description":"With more than 800,000 copies sold since it was first published thirty years ago, The Inner Game of Tennis became a touchstone for hundreds of thousands of people. Now, the bestselling co-author delivers a book designed to help musicians overcome obstacles, improve concentration, and reduce nervousness, allowing them to reach new levels of performing excellence and musical artistry.",
            "spec":{},
            "options":{},
            "tags":"book, improvement,stress anxiety, performance, wisdom, inspiration, knowledge, pedagogy, artistic, culture, education, ",
            "img":1,
            "price":37,
            "uploaded":"6/17/2024",
          },
         
          "item6":{
            "item":"item6",
            "name":"Primary Music Leader's Handbook",
            "author":"Dr Elizabeth Stafford",
            "language":"English",
            "length":"80 pages",
            "publisher":"Collins Music",
            "age":"18 or above",
            "format":"Paperback",
            "ISBN":"978-0008518783",
            "publishyear":"2023",
            "description":"The Primary Music Leader’s Handbook is the essential resource for any music subject leader working in a primary setting. It explains and supports with every aspect of the role – defining your vision, curriculum design, assessment, extra-curricular activities, performances, supporting colleagues – and much more besides.",
            "spec":{},
            "options":{},
            "tags":"book, Aaron Copland, wisdom, inspiration, literature, learning, knowledge, pedagogy, artistic, culture, education, ",
            "img":1,
            "price":35,
            "uploaded":"6/17/2024",
          },
          "item7":{
            "item":"item7",
            "name":"The Music Lesson - A Spiritual Search for Growth through Music",
            "author":"Victor L. Woolten",
            "language":"English",
            "length":"288 pages",
            "publisher":"Berkley",
            "age":"12 or above",
            "format":"Paperback",
            "ISBN":"978-0425220931",
            "publishyear":"2008",
            "description":"The Music Lesson is the story of a struggling young musician who wanted music to be his life, and who wanted his life to be great. Then, from nowhere it seemed, a teacher arrived. Part musical genius, part philosopher, part eccentric wise man, the teacher would guide the young musician on a spiritual journey, and teach him that the gifts we get from music mirror those from life, and every movement, phrase, and chord has its own meaning...All you have to do is find the song inside.",
            "spec":{},
            "options":{},
            "tags":"book, growth, wisdom, learning, inspiration, breakthrough, improvement, performance, knowledge, pedagogy, artistic, culture, education, ",
            "img":1,
            "price":35,
            "uploaded":"6/17/2024",
          },
          "item8":{
            "item":"item8",
            "name":"The Complete Classical Music Guide",
            "author":"Doorling Kindersley",
            "language":"English",
            "length":"352 pages",
            "publisher":"DK Publishing",
            "age":"10 or above",
            "format":"Paperback",
            "ISBN":"978-0241422984",
            "publishyear":"2019",
            "description":"This is an essential guide to more than 1,000 years of classical music. Lose yourself in the fascinating story of classical music in 'The Complete Classical Music Guide'. Full of beautiful colour photographs, over 300 inspiring composer biographies, analyses of major classical works and information on every genre, style and form, instrument and ensemble, this is essential reading for every lover of classical music. Be inspired by the composers who have shaped the musical landscape over a millennia from the earliest music, through the Baroque and Romantic eras and right up to the modern classical music of today. Presented in a beautiful glossy slipcase in the shape of a grand piano, 'The Complete Classical Music Guide' will hit the right note with any classical music fan. All content is previously published in 'Eyewitness Companions: Classical Music'. ",
            "spec":{},
            "options":{},
            "tags":"book, growth, wisdom, learning, inspiration, breakthrough, improvement, performance, knowledge, pedagogy, artistic, culture, education, ",
            "img":1,
            "price":49,
            "uploaded":"6/17/2024",
          },
          "item9":{
            "item":"item9",
            "name":"Oxford Dictionary of Musical Terms",
            "author":"Alison Latham",
            "language":"English",
            "length":"224 pages",
            "publisher":"Oxford University Press",
            "age":"N/A",
            "format":"Paperback",
            "ISBN":"978-0241422984",
            "publishyear":"2005",
            "description":"Printed music and writing about music involve the use of complex systems of notation and a wealth of technical terms in several languages. The Oxford Dictionary of Musical Terms provides clear, succinct, definitions of a comprehensive range of the musical terms, in English and other European languages, that are likely to be encountered in Western music, including in jazz and popular musical genres.",
            "spec":{},
            "options":{},
            "tags":"book, growth, wisdom, learning, inspiration, breakthrough, reference, improvement, performance, knowledge, pedagogy, artistic, culture, education, ",
            "img":1,
            "price":55,
            "uploaded":"6/17/2024",
          },
          "item10":{
            "item":"item10",
            "name":"Help Your Kids with Music",
            "author":"Carol Voderman",
            "language":"English",
            "length":"256 pages",
            "publisher":"DK Publishing",
            "age":"8 to 13",
            "format":"Paperback",
            "ISBN":"978-1465485489",
            "publishyear":"2019",
            "description":"This straightforward guide uses clear, accessible pictures and diagrams to approach even the most complex musical theory with confidence. The use of bright colors breaks up the black and white confusion of musical notes and helps you to easily understand key topics. You’ll also find a glossary of key musical terms and symbols for quick reference, and a supporting audio to help you understand the music you are seeing.",
            "spec":{},
            "options":{},
            "tags":"book, growth, kids, learning, inspiration, improvement, young musicians, performance, knowledge, pedagogy, artistic, culture, education, ",
            "img":1,
            "price":39,
            "uploaded":"6/17/2024",
          },
          "item11":{
            "item":"item11",
            "name":"Psychology of Music",
            "author":"Carl E. Seashore",
            "language":"English",
            "length":"448 pages",
            "publisher":"Dover Publications",
            "age":"15 or above",
            "format":"Paperback",
            "ISBN":"978-0486218519",
            "publishyear":"1967",
            "description":"Between the physical world of vibration, as measured by apparatus, and the world of consciously heard music there is a third area of investigation. Our auditory apparatus and/or mind separates different instruments and tones, hears some vibrations but not others, adds tones to fill out the sound spectrum, etc. This middle ground is the province of the psychology of music, a subject about which even many physical scientists know little.",
            "spec":{},
            "options":{},
            "tags":"book, growth, , learning, inspiration, improvement, thoughts,thinking, musicians, performance, knowledge, pedagogy, artistic, culture, education, ",
            "img":1,
            "price":52,
            "uploaded":"6/17/2024",
          },
          "item12":{
            "item":"item12",
            "name":"Music - A Subversive History",
            "author":"Ted Gioia",
            "language":"English",
            "length":"528 pages",
            "publisher":"Basic Books",
            "age":"13 or above",
            "format":"Paperback",
            "ISBN":"978-1541644366",
            "publishyear":"2019",
            "description":"Histories of music overwhelmingly suppress stories of the outsiders and rebels who created musical revolutions and instead celebrate the mainstream assimilators who borrowed innovations, diluted their impact, and disguised their sources. In Music: A Subversive History, Ted Gioia reclaims the story of music for the riffraff, insurgents, and provocateurs.",
            "spec":{},
            "options":{},
            "tags":"book, time, medival, renaissance, baroque,classical , jazz, learning, inspiration, improvement, thoughts,thinking, musicians, musicology, theory, knowledge, pedagogy, artistic, culture, education, ",
            "img":1,
            "price":49,
            "uploaded":"6/17/2024",
          },
          "item13":{
            "item":"item13",
            "name":"The Art of Practicing - A Guide to Making Music from the Heart",
            "author":"Madeline Bruser",
            "language":"English",
            "length":"288 pages",
            "publisher":"Crown",
            "age":"10 or above",
            "format":"Paperback",
            "ISBN":"978-0609801772",
            "publishyear":"1999",
            "description":"An illustrated guide for the amateur and professional musician that teaches us how to transform practicing from an often laborious activity into an exhilarating and rewarding experience. Foreword by Yehudi Menuhin • 'Give this book to any musician you love and to any person who loves what music does for them and for the world.' — Richard Stoltzman, clarinetist. In The Art of Practicing, acclaimed pianist and teacher Madeline Bruser combines physiological and meditative principles to help musicians release physical and mental tension and unleash their innate musical talent.",
            "spec":{},
            "options":{},
            "tags":"book, time, medival, maestro,musicianship, learning, inspiration, improvement, thoughts,thinking, enhancement, musicians, musicology, theory, knowledge, pedagogy, artistic, culture, education, ",
            "img":1,
            "price":35,
            "uploaded":"6/17/2024",
          },
          "item14":{
            "item":"item14",
            "name":"The Phantom of the Opera",
            "author":"Gaston Leroux",
            "language":"English",
            "length":"368 pages",
            "publisher":"Harper Perennial",
            "age":"13 or above",
            "format":"Paperback",
            "ISBN":"978-0060809249",
            "publishyear":"1987",
            "description":"From the early 20th century that inspired the Lon Chaney film and the hit musical, the story started in the 1880s in Paris where the Palais Garnier Opera House is believed haunted. One night, a young woman, Christine, is asked to sing in place of the Opera's leading soprano, who is ill; Christine's performance is a success, and she is recognized by the Vicomte Raoul, a childhood playmate and love. Raoul and the Phantom then battle for Christine's heart, as the Phantom demands more and more from her.",
            "spec":{},
            "options":{},
            "tags":"book, time, 20th century, ghost, romance, musical, les miserable, tragedy ,musicianship, learning, novel, sad story, french novel, musical story ",
            "img":1,
            "price":27,
            "uploaded":"6/17/2024",
          },
          "item15":{
            "item":"item15",
            "name":"How to Teach Secondary Music",
            "author":"Hanh Doan and David Guinane",
            "language":"English",
            "length":"128 pages",
            "publisher":"Collins Music",
            "age":"15 or above",
            "format":"Paperback",
            "ISBN":"978-1472927378",
            "publishyear":"2017",
            "description":"How to teach Secondary Music presents 100 inspiring ideas to support every aspect of music teaching in secondary schools. The ideas are concise, easy to implement and tackle everything aspect of music teaching. In this invaluable handbook for teachers, the authors present 100 inspiring ideas to support every aspect of music teaching in secondary schools – from lesson planning, behaviour management and recordings through to ensembles, music tours and examinations.",
            "spec":{},
            "options":{},
            "tags":"book, A-level a level, exam, teaching, pedagogy, thinking, music theory knowledge, learning, progress, supplement, exercise, course, teaching material,grades ",
            "img":1,
            "price":39,
            "uploaded":"6/17/2024",
          },
          "item16":{
            "item":"item16",
            "name":"The Elements of Music",
            "author":"Jason Martineau",
            "language":"English",
            "length":"64 pages",
            "publisher":"Bloomsbury USA",
            "age":"10 or above",
            "format":"Paperback",
            "ISBN":"978-0802716828",
            "publishyear":"2008",
            "description":"This innovative book presents the elements of music by building upon the long-known fundamentals of acoustics, proportion and relationship--a kind of musical metaphor. In combination with novel graphics and symbols, the principles behind melody, rhythm, and harmony come alive, along with those of Western musical notation. From intervals, triads, and the circle of fifths to major/minor keys and modulation, Dr. Martineau presents a splendid primer on music theory for the novice and professional alike.",
            "spec":{},
            "options":{},
            "tags":"book, teaching, pedagogy, thinking, music theory knowledge, learning, progress, supplement, exercise, course, teaching material,grades, musicianship, enhance ",
            "img":1,
            "price":36,
            "uploaded":"6/17/2024",
          },
          "item17":{
            "item":"item17",
            "name":"The Musician's Way",
            "author":"Gerald Klickstein",
            "language":"English",
            "length":"368 pages",
            "publisher":"Oxford University Press",
            "age":"12 or above",
            "format":"Paperback",
            "ISBN":"978-0195343137",
            "publishyear":"2009",
            "description":"In The Musician's Way, veteran performer and educator Gerald Klickstein combines the latest research with his 30 years of professional experience to provide aspiring musicians with a roadmap to artistic excellence. Part I, Artful Practice, describes strategies to interpret and memorize compositions, fuel motivation, collaborate, and more. Part II, Fearless Performance, lifts the lid on the hidden causes of nervousness and shows how musicians can become confident performers. ",
            "spec":{},
            "options":{},
            "tags":"book, teaching, pedagogy, thinking, music theory knowledge, learning, progress, supplement, exercise, course, teaching material,grades, musicianship, enhance ",
            "img":1,
            "price":61,
            "uploaded":"6/17/2024",
          },
          "item18":{
            "item":"item18",
            "name":"A Little History of Music",
            "author":"Robert Philip",
            "language":"English",
            "length":"312 pages",
            "publisher":"Yale University Press",
            "age":"10 or above",
            "format":"Paperback",
            "ISBN":"978-0300257748",
            "publishyear":"2023",
            "description":"In this book Robert Philip explores the extraordinary history of music in all its forms, from our earliest ancestors to today’s mass-produced songs. This is a truly global story. Looking to Europe, South America, Asia, Africa, and beyond, Philip reveals how musicians have been brought together by trade and migration and examines the vast impact of colonialism. From Hildegard von Bingen and Clara Schumann to Bob Dylan and Aretha Franklin, great performers and composers have profoundly shaped music as we know it.",
            "spec":{},
            "options":{},
            "tags":"book, teaching, pedagogy, thinking, music theory knowledge, learning, progress, supplement,ancient, medival, renaissance, baroque, classical, course, teaching material,grades, musicianship, enhance ",
            "img":1,
            "price":49,
            "uploaded":"6/17/2024",
          },
          "item19":{
            "item":"item19",
            "name":"A History of Music for Children",
            "author":"Mary Richard, David Schweitzer, et al.",
            "language":"English",
            "length":"96 pages",
            "publisher":"Thames & Hudson",
            "age":"7 to 12",
            "format":"Paperback",
            "ISBN":"978-0500652473",
            "publishyear":"2021",
            "description":"Embark on a musical journey around the world to meet the diverse cast of composers, musicians, and performers who are famous for making the music we love. From Johann Sebastian Bach to Billie Eilish, Hildegard of Bingen to DJ Kool Herc, Wolfgang Mozart to Miriam Makeba, musicians come from many different times and places and introduce music from a wide variety of genres.",
            "spec":{},
            "options":{},
            "tags":"book, teaching, pedagogy,kids, thinking, music theory knowledge, learning, progress, supplement,ancient, medival, renaissance, baroque, classical, course, teaching material,grades, musicianship, enhance ",
            "img":1,
            "price":45,
            "uploaded":"6/17/2024",
          },
          "item20":{
            "item":"item20",
            "name":"A History of Western Music",
            "author":"J. Peter Burkholder",
            "language":"English",
            "length":"1120 pages",
            "publisher":"W. W. Norton & Company",
            "age":"15 or above",
            "format":"Paperback",
            "ISBN":"978-0393668179",
            "publishyear":"2019",
            "description":"The definitive survey, combining current scholarship with a vibrant narrative. Carefully informed by feedback from dozens of scholars, it remains the book that students and teachers trust to explain what’s important, where it fits, and why it matters. Peter Burkholder weaves a compelling story of people, their choices, and the western musical tradition that emerged. From chant to hip-hop, he connects past to present to create a context for tomorrow’s musicians.",
            "spec":{},
            "options":{},
            "tags":"book, teaching, pedagogy, thinking, music theory knowledge, learning, progress, supplement,ancient, medival, renaissance, baroque, classical, course, teaching material,grades, musicianship, enhance ",
            "img":1,
            "price":55,
            "uploaded":"6/17/2024",
          },
          "item21":{
            "item":"item21",
            "name":"For the Love of Music",
            "author":"John Mauceri",
            "language":"English",
            "length":"224 pages",
            "publisher":"Knopf",
            "age":"11 or above",
            "format":"Paperback",
            "ISBN":"978-0525520658",
            "publishyear":"2019",
            "description":"A protégé of Leonard Bernstein - his colleague for 18 years - and an eminent conductor who has toured and recorded all over the world, John Mauceri helps us to reap the joys and pleasures classical music has to offer. Briefly, we learn the way a musical tradition born in ancient Greece, embraced by the Roman Empire, and subsequently nurtured by influences from across the globe, gave shape to the classical music that came to be embraced by cultures from Japan to Bolivia. Then Mauceri examines the music itself, helping us understand what it is we hear when we listen to classical music: how, by a kind of sonic metaphor, it expresses the deepest recesses of human feeling and emotion; how each piece bears the traces of its history; how the concert experience - a unique one each and every time - allows us to discover music anew. Unpretentious, graceful, instructive, this is a book for the aficionado, the novice, and anyone looking to have the love of music fired within them.",
            "spec":{},
            "options":{},
            "tags":"book, teaching, pedagogy,maestro,legends,elite, thinking, music theory knowledge, learning, progress, supplement,ancient, medival, renaissance, baroque, classical, course, teaching material,grades, musicianship, enhance ",
            "img":1,
            "price":39,
            "uploaded":"6/17/2024",
          },
        },
        "tableware":{
          "item1":{
            "item":"item1",
            "name":"Piano Mug and Saucer",
            "description":"Piano inspired mug and saucer.",
            "spec":{"color":"black and white with gold lining","material":"ceremics","dimension":""},
            "price":23,
            "options":{},
            "tags":"tableware, cup, mug, utensils, piano, elegant, china, clay, porcelain, ",
            "img":3,
            "uploaded":"6/17/2024",
          },
          "item2":{
            "item":"item2",
            "name":"Musical Note Decor",
            "description":"Elegant choice for decoration and displaying.",
            "spec":{"color":"Gold or Silver","material":"Plastic with metallic coating","dimension":"approx. 4cm x 8.5cm x 14cm"},
            "price":29,
            "options":{"Color":{1:"Gold",2:"Silver"},"Size":{1:"Large",2:"Medium",3:"Small"}},
            "tags":"tableware, stand, decoration, quaver, statue, elegant, gold and silver, classical, keys",
            "img":7,
            "uploaded":"6/17/2024",
          },
        },
        "wallart":{
          "item1":{
            "item":"item1",
            "name":"Manuscript - Pastiche on Chopin's Valse in Db Major by Sorabji, 1933 [Wall Art Decor]",
            "description":"A classical display of Sorabji's handwritten manuscript of the Pastiche on Chopin's Valse in Db Major Op. 64/1 'Valse du petit chien'. \n\r  -----\n\r Size options: \n\r Small: 30 x 40 cm, \n\rMedium: 40 x 60 cm, \n\rLarge: 70 x 100 cm, \n\rFolio: 80 x 120 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":59,"medium":89,"large":129,"folio":339},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart,painting, drawing, elegant, manuscript, writing, Db, key, chopin, handwritten, art,classical,masterpiece",
            "img":2,
            "uploaded":"6/17/2024",
          },
          "item2":{
            "item":"item2",
            "name":"Guitar Theory Display [Wall Art Decor]",
            "description":"Shows a summary of guitar chords, scales, and music theory. Best for young guitar learners.\n\r-----\n\rSize: 50 x 70 cm",
            "spec":{"dimension":""},
            "price":58,
            "options":{},
            "tags":"wallart,painting, drawing, study, knowledge, writing, education, theory, poster, learning",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item3":{
            "item":"item3",
            "name":"Mozart's Manuscript [Wall Art Decor]",
            "description":"One of Mozart's Orchestral work in its manuscript. A simple yet elegant choice to complement your premise's decor.\n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 60 x 80 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":79,"medium":99,"large":209},
            "options":{"size":{0:"small",1:"medium",2:"large"}},
            "tags":"wallart,painting, drawing, knowledge, mozart, manuscript, writing, classical, art, masterpiece",
            "img":4,
            "uploaded":"6/17/2024",
          },
          "item4":{
            "item":"item4",
            "name":"Piano Theory [Wall Art Decor]",
            "description":"Quick summary of piano chords and theory factsheet. Best for curious junior learners to boost chordal awareness.\n\r-----\n\rSize options:\n\r Petit: 21 x 30 cm,\n\r Small: 30 x 40 cm,\n\r Medium: 35 x 50 cm, \n\r Large: 50 x 70 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"petit":20,"small":29,"medium":39,"large":59},
            "options":{"Color":{0:"Light",1:"Dark"},"size":{0:"petit",1:"small",2:"medium",3:"large"}},
            "tags":"wallart,painting, drawing, knowledge,study, writing, education, theory, poster, learning",
            "img":2,
            "uploaded":"6/17/2024",
          },
          "item5":{
            "item":"item5",
            "name":"Music Party [Wall Art Decor]",
            "painter":"anon.",
            "description":"A portrait displaying a chamber musical event with the audience. A relaxed yet proper ambience to taint your location's ambience into a cultural and musical feast for the eyes.\n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 60 x 80 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":29,"medium":62,"large":119},
            "options":{"size":{0:"small",1:"medium",2:"large"}},
            "tags":"wallart,painting, drawing, salon, party,singing,social,noble,chandelier,baroque, room, chamber, royal, classical, art, masterpiece",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item6":{
            "item":"item6",
            "name":"Backside of a Violinist [Wall Art Decor]",
            "painter":"anon.",
            "description":"A portrait displaying the back side of a female violinist. With the bright golden tone of the canvas, the innocence white color of the chiffon-like fabric conveys mature beauty for the sophisticated. \n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 60 x 80 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":39,"medium":59,"large":85,"folio":149},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart,painting, drawing, violin, backside, chamber, royal, classical, art, masterpiece,room, sexy, elegant",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item7":{
            "item":"item7",
            "name":"Vocal Practice in Chamber [Wall Art Decor]",
            "painter":"anon.",
            "description":"A portrait displaying three women in a chamber practising vocal music accompanied. A feminine and soft depiction that boost sophistication of your desired space. \n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 60 x 80 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":39,"medium":59,"large":85,"folio":149},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart,painting, drawing,curtains, salon, romantic,singing, study, vocal, indoor, three women, 3 girls,room, chamber, piano, classical, art, masterpiece,sexy, elegant",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item8":{
            "item":"item8",
            "name":"Violinist with accompaniment in Chamber [Wall Art Decor]",
            "painter":"anon.",
            "description":"A portrait displaying two women in a chamber practising violin music, adding a touch of ensembleship to a venue. Popular among studio decor. \n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 60 x 80 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":39,"medium":59,"large":85,"folio":149},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart,painting, tutoring, drawing, violin, indoor, two women, 2 girls, chamber, piano, classical, art, room,masterpiece,sexy, elegant",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item9":{
            "item":"item9",
            "name":"Two children in the Piano Room [Wall Art Decor]",
            "painter":"anon.",
            "description":"A portrait displaying two children playing with the piano inside the chamber. Creating an innocence nuance, the painting shall permeate tranquility and youth.\n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 60 x 80 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":39,"medium":59,"large":85,"folio":149},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart,painting, drawing, kids, indoor, two children, study, 2 young, chamber, piano, classical, art, masterpiece,innocence, room,elegant, bright",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item10":{
            "item":"item10",
            "name":"Young Violinist Rehearsing in Chamber [Wall Art Decor]",
            "painter":"anon.",
            "description":"A portrait displaying a young female violinist practising in chamber which gives a sense of rejuvenation and nurturing. Popular among studios. \n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 60 x 80 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":39,"medium":59,"large":85,"folio":149},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart,painting, drawing, kid,curtains, indoor, solo, young, chamber, violin, classical, art, masterpiece,innocence, room,elegant, bright, beauty",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item11":{
            "item":"item11",
            "name":"Lady by the Balcony [Wall Art Decor]",
            "painter":"anon.",
            "description":"A portrait displaying a female sitting in front of the chamber's balcony. Giving the venue a touch of spacial depth and vitality. \n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 60 x 80 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":39,"medium":59,"large":85,"folio":149},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart,painting, drawing, balcony,romantic, curtains,indoor, woman, girl, melancholic, young,sunlight, chamber,lovely,green,plants, classical, room,art, masterpiece,innocence, elegant, bright, beauty",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item12":{
            "item":"item12",
            "name":"Woman Playing the Piano by the Windowside [Wall Art Decor]",
            "painter":"anon.",
            "description":"A portrait depicting a pianist playing by the side of the window. The mystified expression gives a feeling of wonder and mesmerization. \n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 60 x 80 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":39,"medium":59,"large":85,"folio":149},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart,painting, drawing, window,post impressionism, white dress,curtains, indoor,outdoor,plants,green,herb, woman, girl, beauty, young, scenery, chamber, piano,room , classical, art, masterpiece,innocence,studio, elegant, bright, beauty",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item13":{
            "item":"item13",
            "name":"Two Girls Playing at the Piano [Wall Art Decor]",
            "painter":"anon.",
            "description":"Two innocent girls playing the piano together. This conveys a touch of ensembleship, humility and concentratedness. \n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 60 x 80 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":39,"medium":59,"large":85,"folio":149},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart,painting, drawing, piano,real, study, white dress, indoor, women, girl, beauty, young, scenery, chamber, piano,room , classical, art, masterpiece,innocence, elegant, bright, beauty,studio",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item14":{
            "item":"item14",
            "name":"Two Young Girls at the Chamber's Piano [Wall Art Decor]",
            "painter":"anon.",
            "description":"A young girl is practising the piano while the other spectate intriguingly. This conveys a touch of ensembleship, humility and concentratedness. \n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 60 x 80 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":39,"medium":59,"large":85,"folio":149},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart,painting, drawing, window,real, study, pink dress, indoor, woman, girl, beauty, young, scenery, chamber, piano,room , classical, art, masterpiece,innocence, elegant, bright, beauty",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item15":{
            "item":"item15",
            "name":"The Pondering Violinist [Wall Art Decor]",
            "painter":"anon.",
            "description":"A violinist looking out at the window with wonder, displaying a sophisticated posture and composition. Good choice for studio. \n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 60 x 80 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":39,"medium":59,"large":85,"folio":149},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart,painting, drawing, window,white ,suit, indoor, man, boy, handsome,sad,melancholy, young, scenery, chamber, violin,room , classical, art, masterpiece,scores,furniture,chair, elegant, bright,curtains, beauty",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item16":{
            "item":"item16",
            "name":"The Prussian Court Cellist [Wall Art Decor]",
            "painter":"anon.",
            "description":"A nobleman of Prussia like during the Baroque era playing the cello with a female harpsichordist. Accentuating an air of aristocratic occasion. An excellent choice for studio. \n\r-----\n\rSize options:\n\r Small: 35 x 50 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 60 x 80 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":45,"medium":99,"large":159},
            "options":{"size":{0:"small",1:"medium",2:"large"}},
            "tags":"wallart,painting, drawing, salon, chamber, german, baroque, aristocrats, nobleman noblemen, sonata, cello,,white dress,suit, indoor, man, handsome,serious,harpsichord,piano,formal,room , classical, art, masterpiece,scores,furniture,chair, warm tone,lute, beauty",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item17":{
            "item":"item17",
            "name":"Cellist in White Tuxedo [Wall Art Decor]",
            "painter":"anon.",
            "description":"A handsome cellist playing the cello in full motion. The painting radiates energy and dynamics, and gives the venue warmth and a hint of modernism. \n\r-----\n\rSize options:\n\r Small: 35 x 50 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 60 x 80 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":45,"medium":99,"large":159},
            "options":{"size":{0:"small",1:"medium",2:"large"}},
            "tags":"wallart,painting, drawing, cello, salon, tuxedo suit, bow tie, noble, performer, bar,red tone, indoor, man, handsome,serious,vibrant, classical, art, beauty",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item18":{
            "item":"item18",
            "name":"Pianist and Her Students [Wall Art Decor]",
            "painter":"anon.",
            "description":"A woman playing the piano while two other girls study the scores with curiosity. A stylish choice for studio. \n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 60 x 80 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":75,"medium":90,"large":110,"folio":140},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart,painting, drawing, dresses, white, indoor, outdoor, woman, girl, beauty,curtains, window, young, study,learn, chamber, piano,room , classical, art, masterpiece,innocence, elegant, bright, beauty",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item19":{
            "item":"item19",
            "name":"Circle of Fifths Display [Wall Art Decor]",
            "painter":"anon.",
            "description":"For studying venues. Gives a quick summary of the Circle of Fifths and the respective key signatures. \n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 50 x 70 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":36,"medium":65,"large":99,"folio":110},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart, theory, key, signatures, colorful, music theory, grade 5, abrsm, factsheets, learning, study, exam, kids, learners, ",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item20":{
            "item":"item20",
            "name":"Piano Notes [Wall Art Decor]",
            "painter":"anon.",
            "description":"For studying venues. Gives a clear display of the pitches on the keyboard and on the staff. \n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 50 x 70 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":36,"medium":65,"large":99,"folio":110},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart, theory, key, signatures, colorful, music theory, piano, keyboard, pitch, notes, young, starters, grade 5, abrsm, factsheets, learning, study, exam, kids, learners, ",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item21":{
            "item":"item21",
            "name":"Piano Notes - Simple [Wall Art Decor]",
            "painter":"anon.",
            "description":"For studying venues. Gives a simple display of the pitches on the keyboard and on the staff. \n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 50 x 70 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":36,"medium":65,"large":99,"folio":110},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart, theory, key, signatures, colorful, music theory, piano, keyboard, pitch, notes, young, starters, grade 5, abrsm, factsheets, learning, study, exam, kids, learners, ",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item22":{
            "item":"item22",
            "name":"Interval Display [Wall Art Decor]",
            "painter":"anon.",
            "description":"For studying venues. Gives a display of interval. \n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 50 x 70 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":36,"medium":65,"large":99,"folio":110},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart, theory, key, signatures, colorful, music theory, piano, keyboard, pitch, notes, young, starters, grade 5, abrsm, factsheets, learning, study, exam, kids, learners, ",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item23":{
            "item":"item23",
            "name":"Tempo and Dynamics Display [Wall Art Decor]",
            "painter":"anon.",
            "description":"For studying venues. Gives a indicative display of slow to quick tempi and dynamics from loud to soft.  \n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 50 x 70 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":36,"medium":65,"large":99,"folio":110},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart, theory, dynamics, loud soft, pp, mf, mp, ff, f, p,mezzo,sfz, sforzando,crescendo,diminuendo, adagio, lento, allegro, moderato, vivo, vivace, presto, andante, colorful, music theory,grave, young, starters, grade 5, abrsm, factsheets, learning, study, exam, kids, learners, ",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item24":{
            "item":"item24",
            "name":"Values of Musical Notes [Wall Art Decor]",
            "painter":"anon.",
            "description":"For studying venues. Gives a display of value relations of notes. \n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 50 x 70 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":36,"medium":65,"large":99,"folio":110},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart, theory, value, time, counting, music theory, notes, young, starters, grade 5, abrsm, factsheets, learning, study, exam, kids, learners, semibreve, crotchets, minims, quavers, semiquavers ",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item25":{
            "item":"item25",
            "name":"Animated Composers [Wall Art Decor]",
            "painter":"anon.",
            "description":"A cute collection of classical composer portraits in vibrant colors. Best for venues with young music learners. \n\r-----\n\rSize options:\n\r Small: 30 x 40 cm,\n\r Medium: 40 x 60 cm, \n\r Large: 50 x 70 cm,\n\r Folio: 70 x 100 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":45,"medium":89,"large":139},
            "options":{"size":{0:"small",1:"medium",2:"large"}},
            "tags":"wallart, theory, composers, cartoons, colorful, musical giants, Beethoven, Bach, Chopin, Tchaikovsky,Vivaldi, Haydn, Wagner,Mozart, pitch, notes, young, watercolor, starters, learning, study, exam, persons, people, kids, learners, ",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item26":{
            "item":"item26",
            "name":"The Recital [Wall Art Decor]",
            "painter":"Schweninger, Carl",
            "description":"A glamorous musical occasion featuring a solo violinist and the obligato. \n\r-----\n\rSize options:\n\r Small: 50 x 80 cm, \n\r Medium: 60 x 90 cm,\n\r Large: 60 x 120 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":59,"medium":109,"large":329},
            "options":{"size":{0:"small",1:"medium",2:"large"}},
            "tags":"wallart, painting, picture, art, salon, depiction, concert, classical period, evening,chamber, violinist soloist, ensemble,majestic, orchestra, strings, aristocrats",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item27":{
            "item":"item27",
            "name":"Frederick the Great Playing the Flute at Sanssouci [Wall Art Decor]",
            "painter":"Adolph Menzel",
            "description":"The painting depicts in early 19th-century style, an 18th-century musical soirée at the palace at which a piece of music is being played with King Frederick himself playing the flute center stage. However, the monarch’s features represented in the painting are highly idealized as Menzel avoids showing Frederick with his aquiline nose, although he must have known the death mask of the Prussian king. \n\r-----\n\rSize options:\n\r Small: 50 x 80 cm, \n\r Medium: 60 x 90 cm,\n\r Large: 60 x 120 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":61,"medium":119,"large":359},
            "options":{"size":{0:"small",1:"medium",2:"large"}},
            "tags":"wallart, king, monarch, flutist,salon, flute, concerts, classical period, roccoco period, chamber, hall, night, germany, royal, elegant, majestic, glorious ",
            "img":1,
            "uploaded":"6/17/2024",
          },
          "item28":{
            "item":"item28",
            "name":"Violin inside Geometric Scores [Wall Art Decor]",
            "painter":"anon.",
            "description":"A geometric socre containing the depiction of a violin with a bow. A more abstract and contempory choice for the bolder audience. \n\r-----\n\rSize options:\n\r Small: 40 x 40 cm, \n\r Medium: 50 x 50 cm,\n\r Large: 70 x 70 cm,\n\r Folio: 80 x 80 cm",
            "spec":{"weight":"","dimension":""},
            "price":{"small":53,"medium":83,"large":153,"folio":333},
            "options":{"size":{0:"small",1:"medium",2:"large",3:"folio"}},
            "tags":"wallart, scores, music, geometry, pink, depiction, abstract, modern, 2D, simple simplistic minimalism, ",
            "img":6,
            "uploaded":"6/17/2024",
          },
        },
        "yticf":{
          "item1":{
            "item":"item1",
            "name":"Yrete Tenue Certificate Holder Portfolio",
            "description":"Formal Certificate Holder by Yrete Tenue International Culture Fellowship. Syntheric leather in red. A4 size. Elegant way to display your certificates obtained.",
            "spec":{"weight":"","dimension":""},
            "price":42,
            "options":{},
            "tags":"certificate, winner, red, logo, international culture fellowship, leather, A4, coat of arms ",
            "img":2,
            "uploaded":"6/17/2024",
          },
          "item2":{
            "item":"item2",
            "name":"Yrete Tenue Certificate Holder Cylinder",
            "description":"Formal Certificate Holder by Yrete Tenue International Culture Fellowship. Textured exterior in red with logo. Elegant way to store your certificates obtained.",
            "spec":{"weight":"","dimension":""},
            "price":33,
            "options":{},
            "tags":"certificate, circle, winner, red, logo, international culture fellowship, leather, A4, coat of arms",
            "img":2,
            "uploaded":"6/17/2024",
          },
          "item3":{
            "item":"item3",
            "name":"Yrete Tenue Lacquered Badge",
            "description":"Introducing our exquisite Fellowship Crest Lacquered Badge, a perfect blend of elegance and charm. This beautifully designed badge showcases the prestigious artistry of our fellowship, reflecting a commitment to quality and excellence in education. Crafted with meticulous attention to detail, its glossy finish enhances the intricate crest, symbolizing the values we uphold. Whether worn with pride or displayed as a keepsake, this badge is a testament to the distinguished journey of learning and achievement. Elevate your collection with this cute yet sophisticated emblem of prestige.",
            "spec":{"weight":"","dimension":""},
            "price":24,
            "options":{},
            "tags":"badge, winner, brass, metal, horse, logo, international culture fellowship, coat of arms ",
            "img":4,
            "uploaded":"6/17/2024",
          },
        },
        "suit":{
          "item1":{
            "item":"item1",
            "name":"Single Breasted Three Piece Suit with Pleated Shirt",
            "description":"Elevate your wardrobe with our Single Breasted Three Piece Suit including a jacket, a vest a pleated shirt and a pair of trousers. The perfect blend of artistry and luxury. Crafted from premium fabrics, this suit features a tailored fit that enhances your silhouette while providing exceptional comfort.\n\rIdeal for both artistic occasions—such as gallery openings or sophisticated soirées—and luxurious events like weddings or gala dinners, this ensemble exudes confidence and style. The classic single-breasted jacket pairs seamlessly with a waistcoat and trousers, allowing for versatile styling options. \n\rWhether you're making a statement on stage or mingling at an exclusive gathering, this three-piece suit ensures you stand out with elegance and sophistication. Experience the perfect fusion of utility and refinement with this timeless piece.",
            "spec":{"weight":"","dimension":""},
            "price":{"90CM":92,"100CM":96,"110CM":100,"120CM":104,"130CM":108,"140CM":102,"150CM":105,"160CM":108},
            "options":{"size":{0:"90CM",1:"100CM",2:"110CM",3:"120CM",4:"130CM",5:"140CM",6:"150CM",7:"160CM"},
                        "color":{0:"slate grey",1:"camel"}},
            "tags":"tuxedos, suits, winner, formal wear, color, pleated shirt, dinner, luxury, wear, shoes, checked, tie, bow tie, vests, trousers, jackets,",
            "img":10,
            "uploaded":"9/21/2024",
          },
          "item2":{
            "item":"item2",
            "name":"Double Breasted Checked Three Piece Suit with Pleated Shirt",
            "description":"Step into sophistication with our Double Breasted Three Piece Checked Tuxedo, a quintessential choice for the modern gentleman. This tuxedo features a striking checked pattern that adds a contemporary twist to classic elegance, making it perfect for formal occasions.\n\rThe double-breasted jacket offers a tailored silhouette that enhances your stature while exuding confidence and style. Crafted from luxurious fabrics, it combines comfort with a refined aesthetic. The ensemble includes a matching waistcoat and trousers, allowing for a polished look that transitions seamlessly from cocktail parties to black-tie events. \n\rWhether you're attending a wedding, gala, or an upscale dinner, this checked tuxedo ensures you make a lasting impression. Embrace the perfect balance of tradition and modern flair with this exceptional piece that redefines formalwear.",
            "spec":{"weight":"","dimension":""},
            "price":{"90CM":95,"100CM":98,"110CM":103,"120CM":107,"130CM":110,"140CM":114,"150CM":117,"160CM":120},
            "options":{"size":{0:"90CM",1:"100CM",2:"110CM",3:"120CM",4:"130CM",5:"140CM",6:"150CM",7:"160CM"},
                        "color":{0:"khaki",1:"grey"}},
            "tags":"tuxedos, suits, winner, formal wear, color, pleated shirt, dinner, luxury, wear, shoes, checked, tie, bow tie, vests, trousers, jackets,",
            "img":7,
            "uploaded":"9/21/2024",
          },
          "item3":{
            "item":"item3",
            "name":"Double Breasted Three Piece Suit with Pleated Shirt",
            "description":"Discover the elegance of our Double Breasted Three Piece Tuxedo, designed for the discerning young gentleman who appreciates simplicity and sophistication. This tuxedo features a pure, solid-colored fabric that embodies a clean, minimalist aesthetic, making it an ideal choice for formal occasions.\m\rThe double-breasted jacket is tailored to create a flattering silhouette, exuding a polished and refined vibe. Crafted from high-quality materials, it ensures both comfort and style. The ensemble includes a matching waistcoat and trousers, offering a cohesive look that is effortlessly chic.\n\rPerfect for weddings, upscale events, or intimate gatherings, this tuxedo provides a mignon feel that highlights your taste for understated elegance. Elevate your formalwear with this timeless piece that celebrates the beauty of simplicity.",
            "spec":{"weight":"","dimension":""},
            "price":{"90CM":92,"100CM":96,"110CM":100,"120CM":105,"130CM":108,"140CM":112,"150CM":116,"160CM":120},
            "options":{"size":{0:"90CM",1:"100CM",2:"110CM",3:"120CM",4:"130CM",5:"140CM",6:"150CM",7:"160CM"},
                        "color":{0:"black",1:"navy",2:"beige",3:"grey",4:"striped blue",5:"checked blue",6:"checked beige"}},
            "tags":"tuxedos, suits, winner, formal wear, color, pleated shirt, dinner, luxury, wear, shoes, checked, tie, bow tie, vests, trousers, jackets,",
            "img":7,
            "uploaded":"9/21/2024",
          },
        }

      },
      filter:{},
      shoppingCart:{},
      chosenProduct:{},
      checkoutOrder:null,
      frontpageProduct:{
          "1":{"cat":"wallart","item":"item1"},
          "2":{"cat":"wallart","item":"item27"},
          "3":{"cat":"book","item":"item8"},
          "4":{"cat":"book","item":"item4"},
      },
      viewOption:"grid",
      previousView:"frontpage",
      bannerCat:"general",
    }

    this.setval = this.setval.bind(this)
    this.searchProduct = this.searchProduct.bind(this)
  }

  searchProduct(e,searchkey,category){
    //search cat)
    var search_result = {}
    var population = this.state.productList
    if (category !== (null||undefined)){
      population = this.state.productList[category]

      for (var eyetum in population){
        if(
          (this.state.productList[category][eyetum]["name"].toLowerCase().includes(searchkey)) || 
          (this.state.productList[category][eyetum]["description"].toLowerCase().includes(searchkey))||
          (this.state.productList[category][eyetum]["tags"].toLowerCase().includes(searchkey))
        ){
          // alert("itm_in")
          search_result[eyetum] = {}  
            search_result[eyetum] =  this.state.productList[category][eyetum]
            search_result[eyetum]["parentCategory"] = category
        }
      }
      this.setState({filter:search_result,currentPage:"gridviewpage",searchModal:false,bannerCat:category})
    } else {

      for(var catt in population ){
      
        if(catt.toLowerCase().includes(searchkey)){
          // alert("cat_in")
          // search_result[catt] = {}
          for(var itum in this.state.productList[catt]){
            // var keey = catt + itum
            search_result[itum] = this.state.productList[catt][itum]
            search_result[itum]["parentCategory"] = catt
          }
          // alert(JSON.stringify(search_result))
        }
  
        for(var itm in this.state.productList[catt]){
          if(
            (this.state.productList[catt][itm]["name"].toLowerCase().includes(searchkey)) || 
            (this.state.productList[catt][itm]["description"].toLowerCase().includes(searchkey))||
            (this.state.productList[catt][itm]["tags"].toLowerCase().includes(searchkey))
          ){
            // alert("itm_in")
            search_result[itm] = {}  
              search_result[itm] =  this.state.productList[catt][itm]
              search_result[itm]["parentCategory"] = catt
          }
        }
        // alert(JSON.stringify(search_result))
        this.setState({filter:search_result,currentPage:"gridviewpage",searchModal:false,bannerCat:"general"})
        

    }
                        

    }
  }

  setval(obj){
    this.setState(obj);
  }
  render(){

    return (
      <div className="App">

          <div>
              <TopNavbar {...this.state} setval={this.setval} searchProduct={this.searchProduct} />
              <SearchModal {...this.state} setval={this.setval} searchProduct={this.searchProduct} />
              {(this.state.currentPage !== ("frontpage")) && <ToolBar {...this.state} setval={this.setval}/>}
              {(this.state.currentPage==="frontpage") && <FrontPage {...this.state} setval={this.setval} />}
              {(this.state.currentPage==="legalpage") && <LegalPage {...this.state} setval={this.setval} />}
              {(this.state.currentPage==="listpage") && <ListPage {...this.state} setval={this.setval} />}
              {(this.state.currentPage==="gridviewpage") && <GridViewPage {...this.state} setval={this.setval} />}
              {(this.state.currentPage==="detailpage") && <DetailPage {...this.state} setval={this.setval} />}
              {(this.state.currentPage==="shoppingcart") && <ShoppingCart {...this.state} setval={this.setval} />}
              <Footer {...this.state} setval={this.setval}/>
          </div>


      </div>
    );


  }
}

export default App;
